
















































































































































































































































































































































if (top.location.hostname != self.location.hostname) {
  top.location.href = self.location.href;
}
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import PasswordInput from "@/components/forms/PasswordInput.vue";
import NewPasswordInput from "@/components/forms/NewPasswordInput.vue";
import GoogleLogin from "@/components/GoogleLogin.vue";
import consts from "../../consts";
import { validateEmail, validateMembers, parseAuthToken } from "../../utils";
// import { sortAlphabetical, parseAuthToken } from "./utils";
import {
  loginEmail,
  signupEmail,
  loginSocial,
  resetPassword,
  setCookie,
} from "../../auth";
import { MemberToAdd, User, LearnerTeam, UserSelf } from "../../types";
import amplitude from "amplitude-js";
import axios from "axios";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import VueCookies from "vue-cookies";
import { Getter, Action } from "vuex-class";
import { parseJwt, getDomain } from "@/auth";
import Splash from "@/components/partials/Splash.vue";
import { teamCode } from "@/api";
import { Route } from "vue-router";
//import { User, UserSelf } from "@/types";

enum Mode {
  Signup = "Signup",
  Login = "Login",
}
@Component({
  components: {
    PasswordInput,
    Splash,
    NewPasswordInput,
    GoogleLogin,
  },
})
export default class Login extends Vue {
  @Getter private JWT!: string;
  @Getter private UID!: string;
  @Action private setJWT: any;
  @Action private resetState: any;
  @Action private setUID: any;
  @Action private setInitAssessment: any;
  @Action private fetchLearnerTeams!: (
    onSuccess: Function,
    onError: Function
  ) => any;

  private loggingIn: boolean = false;
  private email: string = "";
  private confirmEmail: string = "";
  private emailMatched: boolean = false;
  private showError: boolean = false;
  private password: string = "";
  private name: string = "";
  private passwordValid: boolean = false;
  private ssoEmailAddress: string = "";
  private forgotEmail: string = "";
  private linkingCompany: boolean = false;
  private isForgotPassword: boolean = false;
  private forgotPasswordError: boolean = false;
  private linkingError: boolean = false;
  private loginError: boolean = false;
  private forgotErrorMessage: string = "";
  private errorMessage: string = "";
  private successForgotPassword: string = "";
  private $amplitude: any;
  private loading = true;
  private mode: Mode = Mode.Login;
  private affiliateCode?: string;
  private ssoEnabled: boolean = false;

  private userEmail?: string;

  private teamCodeError: string = "";

  // NOTE: Cookie is set inside auth functions in auth.ts perhaps we should refactor that out to here.
  private created() {
    // Setup amplitude
    source.cancel();
    let domain = getDomain(window.location.href) as string | undefined;
    this.$cookies.remove("ORAI_AUTH", "/", domain);
    this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    localStorage.clear();
    this.resetState();
    refreshAxiosCancelToken();
    amplitude.getInstance().init(consts.amplitudeKey, "", {
      saveEvents: true,
      includeUtm: true,
      includeReferrer: true,
    });
    this.$amplitude = amplitude.getInstance();
    if (this.$route.query.token) {
      this.checkAuth(this.$route.query.token as string);
    } else {
      this.loading = false;
    }

    if (this.$route.query.email) this.email = this.$route.query.email as string;
  }

  get passwordHideHelper() {
    if (this.mode === "Login" || this.passwordValid) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Update JWT and UID into the store
   * if required. JWT and UID is already set in
   * login.vue if that flow is used.
   */
  private setAuthVars(jwt: string) {
    this.setJWT(jwt);
    let authParams = parseAuthToken(jwt);
    this.setUID(authParams.uid);
  }

  private async loginWithGoogle(loginData) {
    setCookie(loginData.jwt);
    const user: UserSelf = await loginData.user;
    console.log("LOGIN WITH GOOGLE", user);
    const jwt = loginData.jwt;
    if (localStorage.invitetoken) {
      const temp = localStorage.invitetoken;
      localStorage.removeItem("invitetoken");
      this.$router.push({
        name: "invite",
        params: { inviteID: temp },
      });
      return;
    }
    this.setInitAssessment(user.doneJourneyOnboarding);
    this.setAuthVars(jwt);
    //return this.route();
    this.$router.push({ name: "home" });
  }

  private checkAuth(SSOToken: string) {
    // let JWT = this.$cookies.get("ORAI_AUTH");
    // getURLParam("token", window.location);
    if (SSOToken) {
      SSOToken = SSOToken as string;
      // Looks like some invite token hack
      // todo: look into this and refactor possibly with store
      loginSocial(
        SSOToken,
        (jwt: string, user: UserSelf) => {
          if (localStorage.invitetoken) {
            const temp = localStorage.invitetoken;
            localStorage.removeItem("invitetoken");
            this.$router.push({
              name: "invite",
              params: { inviteID: temp },
            });
            return;
          }
          this.setInitAssessment(user.doneJourneyOnboarding);
          this.setAuthVars(jwt);
          return this.route();
        },
        (err: any) => {
          console.error(err);
        }
      );
    }
  }

  private handleSSOClick() {
    this.isForgotPassword = false;
    this.linkingCompany = true;
    this.linkingError = false;
    this.ssoEmailAddress = "";
    this.$amplitude.logEvent("Login_SSOButton");
  }

  private toggleMode() {
    if (this.mode === Mode.Login) {
      if (this.$route.query.team_code)
        this.$router.push(`/signup/?team_code=${this.$route.query.team_code}`);
      else this.$router.push("/signup");
    } else {
      if (this.email) this.email = "";
      if (this.$route.query.team_code)
        this.$router.push(`/login/?team_code=${this.$route.query.team_code}`);
      else this.$router.push("/login");
    }
  }
  private matchEmail() {
    if (true) {
      if (this.email === this.confirmEmail) {
        this.showError = false;
        this.emailMatched = true;
      } else {
        this.emailMatched = false;
        this.showError = true;
      }
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onRouteChange(newRoute: Route) {
    if (newRoute.name === "signup") {
      this.mode = Mode.Signup;
    } else if (this.$route.name === "signupAffiliate") {
      this.mode = Mode.Signup;
      this.affiliateCode = this.$route.params["affiliate"];
      this.$router.replace("/signup");
    } else {
      this.mode = Mode.Login;
    }
  }

  private handleForgotPassword() {
    this.isForgotPassword = true;
    this.forgotEmail = "";
    this.successForgotPassword = "";
  }

  @Watch("forgotEmail")
  private onforgotEmailChange() {
    this.forgotPasswordError = false;
    this.forgotErrorMessage = "";
  }

  private handleCancelForgotPassword() {
    this.isForgotPassword = false;
  }

  private handleCancelClick() {
    this.linkingCompany = false;
    this.$amplitude.logEvent("LoginSSO_CancelButton");
  }

  private handleContactClick() {
    this.linkingCompany = false;
    this.$amplitude.logEvent("LoginSSO_ContactLink");

    axios({
      method: "POST",
      url: "",
      data: {
        user: "User SSO Domain Issue",
        attachments: [
          {
            title: "Invalid Domain",
            author_name: "Manager",
            text: "[domain tried]",
          },
        ],
      },
    })
      .then((resp) => {
        console.log("CONTACT HOOK", resp.data);
      })
      .catch((reason) => {
        console.log(reason, reason.response);
      });
  }

  private validateForm(email: string, onlyEmail: boolean = false) {
    // return false;
    if (onlyEmail) {
      return validateEmail(email);
    } else if (this.mode === "Signup") {
      return (
        validateEmail(email) &&
        this.passwordValid &&
        this.name.length > 1 &&
        this.emailMatched
      );
    } else {
      return validateEmail(email) && this.password && this.password.length > 0;
    }
  }

  private setJWTUID(jwt: string) {
    const mydata = parseJwt(jwt);
    this.setJWT(jwt);
    this.setUID(mydata.uid);
  }

  private route() {
    if (this.$route.params.redirect) {
      this.$router.replace(this.$route.params.redirect);
      return;
    } else if (this.$route.query.redirect) {
      this.$router.replace(this.$route.query.redirect as string);
      return;
    }
    // {
    //   path: "lesson/:lid/ex/:eid",
    //   name: "exercise",
    //   component: ExerciseView,
    //   props: true
    // },
    if (this.$route.query.app) {
      this.$router.push({ name: "learner" });
      return;
    }
    if (this.$route.query.lesson_id && this.$route.query.exercise_id) {
      this.$router.push({
        name: "exercise",
        params: {
          lid: this.$route.query.lesson_id.toString(),
          eid: this.$route.query.exercise_id.toString(),
        },
      });
      return;
    }

    this.$router.push({ name: "home" });
  }

  private logInOnEnter() {
    if (this.validateForm(this.email)) {
      this.logIn();
    }
  }

  private logIn() {
    this.loggingIn = true;
    this.loginError = false;
    this.errorMessage = "";
    this.$amplitude.logEvent("Login_SignupButton");
    if (this.mode === "Login") {
      this.$amplitude.logEvent("Login");

      loginEmail(
        this.email,
        this.password,
        (jwt: string, user: UserSelf) => {
          this.setInitAssessment(user.doneJourneyOnboarding);
          this.setJWTUID(jwt);
          if (this.$route.query.team_code) this.setTeamCode();
          return this.route();
        },
        (error: string) => {
          this.loggingIn = false;
          this.loginError = true;
          this.errorMessage = error;
        }
      );
    } else {
      this.$amplitude.logEvent("Signup");

      signupEmail(
        this.email,
        this.password,
        this.name,
        this.affiliateCode,
        (jwt: string, user: UserSelf) => {
          this.setInitAssessment(user.doneJourneyOnboarding);
          this.setJWTUID(jwt);
          if (this.$route.query.team_code) this.setTeamCode();
          //return this.route(); //this.$router.push('/subscribe');
          this.$router.push({
            path: "/learner/home",
          });
        },
        (error: string) => {
          this.loggingIn = false;
          this.loginError = true;
          this.errorMessage = error;
        }
      );
    }
  }

  private setTeamCode() {
    this.teamCodeError = "";
    let team_code = "" + this.$route.query.team_code;
    teamCode(
      this.JWT,
      this.UID,
      team_code,
      (success: string) => {
        console.log("joined team");
      },
      (error: string) => {
        console.log(error, ">>>>>>>>>.");

        this.teamCodeError = error;
      }
    );
  }

  private linkCompany() {
    this.loggingIn = true;
    this.$amplitude.logEvent("LoginSSO_LinkButton");
    axios
      .get(
        consts.serverURL +
          "saml/sso/email/" +
          this.ssoEmailAddress +
          "?relay=" +
          window.location.hostname +
          "&customtarget=" +
          window.location.origin
      )
      .then((resp) => {
        console.log("LINK COMPANY", resp.data);
        if (resp.data.URL) {
          window.location = resp.data.URL;
        }
      })
      .catch((reason) => {
        this.loggingIn = false;
        console.log(reason, reason.response);
        this.linkingError = true;
      });
  }

  private forgotPasswordOnEnter() {
    if (this.validateForm(this.forgotEmail, true)) {
      this.forgotPassword();
    }
  }

  private forgotPassword() {
    this.loggingIn = true;
    this.forgotPasswordError = false;
    this.forgotErrorMessage = "";
    this.successForgotPassword = "";
    resetPassword(
      this.forgotEmail,
      (description: string) => {
        this.successForgotPassword = description;
        this.loggingIn = false;
      },
      (error: string) => {
        this.loggingIn = false;
        this.forgotPasswordError = true;
        this.forgotErrorMessage = error;
      }
    );
  }
}
